module.exports = __webpack_public_path__ + "media/images/chart_sign-fec915274836beb71c2d1ee087ca054d.svg";